import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const FRAGMENTS = {
  BUTTON: '[data-fragment="Collapse.button"]',
};

class Collapse extends WebComponent {
  static defaultProps = {
    activeItemClassName: 'active',
    allowOneActiveItem: false,
    waiAriaControls: 'aria-controls',
    waiAriaLabelledby: 'aria-labelledby',
    waiAriaExpanded: 'aria-expanded',
  }

  constructor(props) {
    super(props);
    this.objects = {};
    this.objects.buttons = null;

    this.handleClick = this.handleClick.bind(this);
    this.handleLoad = this.handleLoad.bind(this);
  }

  didMount() {
    this.objects.buttons = this.element.querySelectorAll(FRAGMENTS.BUTTON);

    window.addEventListener('load', this.handleLoad);

    if (this.objects.buttons) {
      [...this.objects.buttons].forEach((button) => {
        button.addEventListener('click', this.handleClick);
      });
    }
  }

  willUnMount() {
    window.removeEventListener('load', this.handleLoad);

    if (this.objects.buttons) {
      [...this.objects.buttons].forEach((button) => {
        button.addEventListener('click', this.handleClick);
      });
    }
  }

  getElementTarget(buttonElement) {
    const {
      waiAriaControls,
    } = this.props;

    const targetId = buttonElement.getAttribute(waiAriaControls);
    return this.element.querySelector(`#${targetId}`);
  }

  showContent(buttonElement) {
    const {
      activeItemClassName,
      waiAriaExpanded,
    } = this.props;

    buttonElement.setAttribute(waiAriaExpanded, 'true');
    this.getElementTarget(buttonElement).classList.add(activeItemClassName);
  }

  hideContent(buttonElement) {
    const {
      activeItemClassName,
      waiAriaExpanded,
    } = this.props;

    buttonElement.setAttribute(waiAriaExpanded, 'false');
    this.getElementTarget(buttonElement).classList.remove(activeItemClassName);
  }

  handleClick(e) {
    const {
      allowOneActiveItem,
      waiAriaExpanded,
    } = this.props;

    const eTButtonElement = e.target.closest(FRAGMENTS.BUTTON);

    if (allowOneActiveItem) {
      [...this.objects.buttons].forEach((button) => {
        if (eTButtonElement !== button) {
          this.hideContent(button);
        }
      });
    }

    if (eTButtonElement.getAttribute(waiAriaExpanded) === 'true') {
      this.hideContent(eTButtonElement);
    } else {
      this.showContent(eTButtonElement);
    }
  }

  handleLoad() {
    const {
      waiAriaLabelledby,
    } = this.props;

    if (location.hash !== null && location.hash !== '') {
      const locationSelector = location.hash.replace('#', '');
      const buttonSelector = this.element.querySelector(`#${locationSelector}`).getAttribute(waiAriaLabelledby);
      const buttonElement = this.element.querySelector(`#${buttonSelector}`);
      buttonElement.dispatchEvent(new Event('click'));
    }
  }
}

export default Collapse;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Collapse.js